export const dropzoneMessages = {
  dictDefaultMessage: "Klik of sleep bestanden hierheen om ze te uploaden",
  dictFallbackMessage: "Uw browser ondersteunt het slepen van bestanden niet.",
  dictFallbackText: "Gebruik het formulier hieronder om uw bestanden te uploaden.",
  dictFileTooBig: "Het bestand is te groot ({{filesize}} MB). De maximale grootte is {{maxFilesize}} MB.",
  dictInvalidFileType: "Dit type bestand kunt u hier niet uploaden.",
  dictResponseError: "Er ging iets mis bij het uploaden (foutcode {{statusCode}}). Probeer het later nog eens.",
  dictCancelUpload: "Upload annuleren",
  dictUploadCanceled: "Upload geannuleerd.",
  dictCancelUploadConfirmation: "Weet u zeker dat u deze upload wilt annuleren?",
  dictRemoveFile: "Bestand verwijderen",
  dictMaxFilesExceeded: "U kunt geen bestanden meer uploaden.",
}

/**
 * Makes every Dropzone on the page use the Dutch messages, unless it sets its own text.
 * Inline scripts create Dropzones before this deferred module runs; Dropzone reads the texts lazily, so patch them.
 *
 * @param {typeof Dropzone} Dropzone the Sprockets Dropzone global
 */
export function localizeDropzone(Dropzone) {
  const defaults = Dropzone.prototype.defaultOptions

  for (const dropzone of Dropzone.instances) {
    for (const [key, message] of Object.entries(dropzoneMessages)) {
      if (dropzone.options[key] === defaults[key]) dropzone.options[key] = message
    }
  }
  Object.assign(defaults, dropzoneMessages)
}
